import React, { Component } from 'react';
// import './../../assets/index.css';
import $ from 'jquery';
import { browserHistory } from 'react-router';
import WebHeaderInner from './../Common/WebHeaderInner.js';
import WebFooter from './../Common/WebFooter.js';

export default class Web_Forgot extends Component {
  constructor(props,context){
  	super(props);
  	this.router = context.router;
  	this.state={
  		token: localStorage.token,
      err: false,
      invalid_num: '',
  	}
  	this.handleSubmit= this.handleSubmit.bind(this);
    this.onMobileChange=this.onMobileChange.bind(this);
  }
  handleSubmit(event){
  		event.preventDefault();
      var baseUrl='https://aquadeals.in/admin/web3/user/';
      // var mobile= this.refs.mobile.value;
  		var data1 = {
  			from: 'desktop_web',
        mobile: this.refs.mobile.value,
        device_id: localStorage.getItem('push_device_id')
      }
  		var data2=JSON.stringify(data1);
      $.ajax({
  			method: 'POST',
  			url: baseUrl+'forgotOtp',
  			data: {req:data2},
  			dataType: 'json',
  			success: function(data){
  				// console.log(data);
  				if(data.status==="success"){
  				  localStorage.setItem('mobile',data.mobile);
              this.setState({
              err: false,
            })
            browserHistory.push('/web/verify');
            window.location.reload();
              }
            else if(data.status ==='fail'){
              this.setState({
                err: true,
                invalid_num: data.msg
              })
            }
            else if(data.status === 'Mobile number is not registerd with us'){
              this.setState({
                err: true,
                invalid_num: data.status,
              })
            }
  			}.bind(this),
  			error: function(err){
  				// console.log("Forgot Password" + err);
  			}

  		})
  	}

  onMobileChange(event){
    var invalidChars = /[^0-9]/gi;
    if(invalidChars.test(event.target.value)) {
      event.target.value = event.target.value.replace(invalidChars, "");
    }
  }
  render(){
    localStorage.removeItem('h_type');
    return (
    <div className="lgt_gry">
        <WebHeaderInner />
        <div className="clr">&nbsp;</div>
        <div className="clr">&nbsp;</div>
        <section className="container dels_cntnt">
            <div className="row">
              <div className="col-md-12 del_rgt">
                  <div className="del_rgt_blk">
                      <div className="del_dtl">
                        <div className="">
                            <div className="col-md-6 col-md-offset-3">
                                <div className="clr">&nbsp;</div>
                                <div className="clr">&nbsp;</div>
                                <div className="thumbnail">
                                    <div className="enquire_form signup_blk proced_blk">
                                        <h5 className="mob_nmbr_title">Submit your Mobile Number to Reset Password</h5>
                                        <div className="clr">&nbsp;</div>
                                        <div className="clr">&nbsp;</div>
                                        <form className="mtrl_elmnts" onSubmit={this.handleSubmit}>
                                            <div className="col-md-12 col-xs-12 col-sm-12">
                                               <div className="col-md-12 col-xs-12 col-sm-12">
                                                  <div className="group">      
                                                    <input type="text" maxLength={10} required ref="mobile" onChange={this.onMobileChange} />
                                                    <span className="highlight"></span>
                                                    <span className="bar"></span>
                                                    <span>{this.state.err ? this.state.invalid_num : ''}</span>
                                                    <label>Mobile</label>
                                                  </div>
                                                </div>
                                            </div>
                                            <div className="clr">&nbsp;</div>
                                            <div style={{border: 'none',overflow:'hidden'}}>
                                                <div className="col-md-12 col-xs-12 col-sm-12 proced_btn"><button action="submit" className="btn signup_btn" onSubmit={this.handleSubmit}>Submit</button></div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="clr">&nbsp;</div>
                        <div className="clr">&nbsp;</div>
                      </div>
                  </div>
                </div>
            </div>
            <div className="clr">&nbsp;</div> 
            <div className="clr">&nbsp;</div>
        </section>
        <WebFooter />
    </div>
    );
    }
  }


/** WEBPACK FOOTER **
 ** ./src/Desktop/components/Auth/Web_forgot.js
 **/